import {ApckPortletRecentScans} from "./recentscans";

export const ApckPortletRunningScans = /*#__PURE__*/ ApckPortletRecentScans.extend({
    props: {
        ctype: {
            type: String,
            default: "runningscansportlet"
        },
        title: {
            type: String,
            default: "Running Scans"
        },
        size: {
            type: String,
            default: "lg"
        },
        description: {
            type: String,
            default: "A quick access table of running scans"
        },
        src: {
            type: String,
            default: "/runningscans"
        },
    },
});
